console.log("Initialisiere benutzerdefinierte Skripte");

function createJumpMenu(targetSelector, dockTarget) {
  setTimeout(function () {
    /*    _____             __ _       
     / ____|           / _(_)      
    | |     ___  _ __ | |_ _  __ _ 
    | |    / _ \| '_ \|  _| |/ _` |
    | |___| (_) | | | | | | | (_| |
     \_____\___/|_| |_|_| |_|\__, |
                              __/ |
                             |___/   */

    /*  const targetSelector = "#MainContent>.shopify-section:not(.index-section) h2"; // Definiert welche Elemente ins Sprungmarkenmenü aufgenommen werden. Standard: ".subheading"
  const dockTarget = "#SiteHeader"; // Definiert am Ende welchen Elements das Sprungmarkenmenü angefügt werden soll. Standard: "#SiteHeader" */

    /*#######################################################################
    End of Config. Don't edit below this line or you'll likely break stuff.
  #######################################################################*/

    var subheadings = document.querySelectorAll(targetSelector);

    // Finde den HeaderWrapper, um dessen Höhe für das Berechnen eines Sprungmarken-Offsets zu nutzen.
    var headerWrapper = document.getElementById("SiteHeader");
    var headerWrapperHeight;
    if (headerWrapper !== null) {
      // Überprüfe, ob das Element existiert, bevor die Höhe bestimmt wird
      headerWrapperHeight = headerWrapper.offsetHeight; // Bestimme die Höhe des Elements
      headerWrapperHeight += headerWrapperHeight;

      console.log(
        "Höhe des HeaderWrapper-Elements:",
        headerWrapperHeight,
        "Pixel"
      );
    } else {
      console.log("HeaderWrapper existiert nicht.");
      headerWrapperHeight = 150;
    }

    // Erstelle unsichtbare DIV-Elemente für jedes subheading und füge sie ein
    subheadings.forEach(function (heading) {
      // Extrahiere den Textinhalt des Elements
      var text = heading.textContent.trim();

      // Erstelle eine ID aus dem Textinhalt

      var id = generateId(text.toLowerCase());

      // Erzeuge ein unsichtbares DIV-Element
      if (text.length > 3 && id !== null) {
        var invisibleDiv = document.createElement("div");
        invisibleDiv.id = id;

        invisibleDiv.style.cssText =
          "visibility: hidden; height: 0px !important; position: absolute; margin: -" +
          headerWrapperHeight +
          "px;";

        heading.parentNode.insertBefore(invisibleDiv, heading); // Füge das unsichtbare DIV-Element vor dem aktuellen subheading ein
      }
    });

    // Erstelle ein Sprungmarkenmenü
    var menuHTML = '<ul id="sprungmarkenmenue">';
    subheadings.forEach(function (heading) {
      // Extrahiere den Textinhalt des Elements
      var text = heading.textContent.trim();
      var id = generateId(text.toLowerCase());

      if (text.length > 3 && id !== null) {
        // Füge einen Eintrag zum Sprungmarkenmenü hinzu
        menuHTML += '<li><a href="#' + id + '">' + text + "</a></li>";
      }
    });

    menuHTML += "</ul>";

    // Finde das Element an dem das Menü angehaftet werden soll
    var navigationElement = document.querySelector(dockTarget);

    var subheadings = document.querySelectorAll(targetSelector);
    if (subheadings.length >= 2) {
      // Füge das Sprungmarkenmenü am Ende eines Elements ein
      navigationElement.insertAdjacentHTML("beforeend", menuHTML);
      console.log(
        subheadings.length + " Elemente gefunden. Sprungmarkenmenü erstellt."
      );
    } else {
      console.log(
        "Es gibt " +
          subheadings.length +
          " Elemente. Kein Sprungmarkenmenü erstellt."
      );
    }

    // Füge einen Event Listener zu allen Links im Menü hinzu
    var menuLinks = document.querySelectorAll("#sprungmarkenmenue a");
    menuLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // Verhindere das Standard-Verhalten des Links

        var targetId = this.getAttribute("href").substring(1); // Extrahiere die ID des Ankerpunkts
        var targetElement = document.getElementById(targetId); // Finde das Ziel-Element

        // Scrolle sanft zum Ziel-Element
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start", // Den Ankerpunkt oben im sichtbaren Bereich ausrichten
          inline: "nearest", // Standardausrichtung beibehalten
        });
      });
    });

    /*
    // Erstellen Sie einen IntersectionObserver
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Wenn das unsichtbare DIV im sichtbaren Bereich ist
        if (entry.isIntersecting) {
          // Extrahieren Sie die ID des unsichtbaren DIVs
          var targetId = entry.target.id;

          // Finden Sie den entsprechenden Link im Sprungmarkenmenü
          var targetLink = document.querySelector('a[href="#' + targetId + '"]');

          // Unterstreichen Sie den Link, wenn er gefunden wird
          if (targetLink) {
            targetLink.style.transition = "all 1.5s";
            targetLink.style.textDecoration = "underline";
            targetLink.style.textUnderlinePosition = "under";
            targetLink.style.fontSize = "1.05em";
          }
        } else {

          setTimeout(function() {
            
          // Wenn das unsichtbare DIV nicht mehr im sichtbaren Bereich ist, entfernen Sie das Unterstreichen
          var targetId = entry.target.id;
          var targetLink = document.querySelector('a[href="#' + targetId + '"]');
          if (targetLink) {
            targetLink.style.textDecoration = "none";
            targetLink.style.fontSize = "inherit";
          }

          }, 800); // 800ms Verzögerung
          
        }
      });
    }, { rootMargin: `-${headerWrapperHeight}px 0px 0px 0px` }); */

    // Überwache alle unsichtbaren DIVs
    subheadings.forEach(function (heading) {
      var text = heading.textContent.trim();
      //console.log("Text:" + text);
      var id = generateId(text.toLowerCase());
      var invisibleDiv = document.getElementById(id);
      //console.log("invisibleDiv:" + invisibleDiv);
      //observer.observe(invisibleDiv);
    });
  }, 750); // 750ms Verzögerung
}

// Erstelle eine ID aus dem Textinhalt
function generateId(text) {
  var id = text
    .toLowerCase()
    .replace(/[ä]/g, "ae")
    .replace(/[ü]/g, "ue")
    .replace(/[ö]/g, "oe")
    .replace(/[Ä]/g, "ae")
    .replace(/[Ü]/g, "ue")
    .replace(/[Ö]/g, "oe")
    .replace(/[.]/g, "")
    .replace(/[,]/g, "")
    .replace(/["']/g, "")
    .replace(/\s+/g, "-");

  if (id.length > 64) {
    id = id.substring(0, 64);
  }

  return id;
}

// Career ELement
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".career-listing-header")
    .forEach(function (header) {
      header.addEventListener("click", function () {
        var details = this.nextElementSibling;
        var arrow = this.querySelector(".career-toggle-arrow");
        var toggleText = this.querySelector(".career-toggle-text");

        if (details.style.maxHeight) {
          details.style.maxHeight = null;
          toggleText.textContent = "Details öffnen";
          arrow.textContent = "▼";
        } else {
          details.style.maxHeight = details.scrollHeight + "px";
          toggleText.textContent = "Details schließen";
          arrow.textContent = "▲";
        }
      });
    });
});

// Rhiantis "Show more"-Toggle, ausgelagert aus text-and-image.liquid
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".text-and-image-more-btn").forEach((item) => {
    item.addEventListener("click", function () {
      const description = item.parentElement.querySelector(
        ".custom-description"
      );
      if (description.classList.contains("no-toggle")) return; // Skip toggle if no-toggle class is present

      description.classList.toggle("visible");
      const moreBtn = item.querySelector(".product-details__more-btn--more");
      const lessBtn = item.querySelector(".product-details__more-btn--less");
      const iconArrow = item.querySelector(".icon-arrow");
      item.classList.toggle("open");
      if (description.classList.contains("visible")) {
        moreBtn.style.display = "none";
        lessBtn.style.display = "inline";
      } else {
        moreBtn.style.display = "inline";
        lessBtn.style.display = "none";
      }
    });
  });
  document.querySelectorAll(".custom-description").forEach((item) => {
    if (item.classList.contains("no-toggle")) return; // Skip fade logic if no-toggle class is present

    if (item.scrollHeight > 400) {
      const moreBtn = item.parentElement.querySelector(
        ".text-and-image-more-btn"
      );
      moreBtn.classList.add("visible");
      item.classList.add("has-fade"); // Add fade only if the button is visible
      moreBtn.querySelector(".product-details__more-btn--more").style.display =
        "inline";
      moreBtn.querySelector(".product-details__more-btn--less").style.display =
        "none";
    } else {
      item.classList.add("no-fade");
    }
  });
});

// Fußzeilenmenü "Rechtliches" muss immer ausgefahren sein (Vorschrift!) -TS-2024-06-24
document.addEventListener("DOMContentLoaded", function () {
  // Prüfen, ob die Anzeigebreite kleiner als 590px ist
  if (window.innerWidth < 590) {
    // Element mit der gewünschten Klasse suchen
    var button = document.querySelector(
      ".grid__item.footer__item--footer-1 button"
    );

    // Prüfen, ob das Element existiert
    if (button) {
      // Element anklicken
      button.click();
    }
  }
});

// Browser-Spezifischer Fix (Safari) für ts-features-collection-switcher -TS-2024-06-24
document.addEventListener("DOMContentLoaded", function () {
  // Funktion zur Erkennung von Safari
  function isSafari() {
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1;
  }
  // Überprüfen, ob der Browser Safari ist
  if (isSafari()) {
    // CSS-Regel hinzufügen
    var style = document.createElement("style");
    style.innerHTML = `
            div[id*="__ts_featured_collection_switcher_"] .flickity-slider {
                max-height: 368px;
            }
        `;
    document.head.appendChild(style);
  }
});

// Sektion "TS Periodic Table" sections/ts-period.liquid
window.addEventListener("DOMContentLoaded", function () {
  // Modal Steuerung
  const cells = document.querySelectorAll(".cell.filled");
  const modals = document.querySelectorAll(".modal");
  const spans = document.getElementsByClassName("close");

  cells.forEach((cell) => {
    cell.addEventListener("click", function () {
      const modalId = this.getAttribute("data-modal");
      document.getElementById(modalId).style.display = "block";
    });
  });

  Array.from(spans).forEach((span) => {
    span.addEventListener("click", function () {
      Array.from(modals).forEach((modal) => (modal.style.display = "none"));
    });
  });

  window.addEventListener("click", function (event) {
    if (event.target.className === "modal") {
      Array.from(modals).forEach((modal) => (modal.style.display = "none"));
    }
  });

  //Nummern von Text trennen
    const filledCells = document.querySelectorAll('.cell.filled');

    filledCells.forEach(cell => {
        const content = cell.textContent.trim();
        const numberMatch = content.match(/(\d+)/);
        
        if (numberMatch) {
            const number = numberMatch[0];
            const text = content.replace(number, '').trim();

            cell.innerHTML = `<span class="pt-num">${number}</span><span class="pt-text">${text}</span>`;
        } else {
            cell.innerHTML = `<span class="pt-text">${content}</span>`;
        }
    });


  const tableContainer = document.querySelector('.table-container');
  if (tableContainer) {
  (function() {
  // Function to add the .js-gen elements
  function addJsGenElements() {
    // Select all the cells that are not hidden and do not have the .js-gen class
    const cells = Array.from(document.querySelectorAll('.cell:not(.js-gen)')).filter(cell => getComputedStyle(cell).display !== 'none');

    if (cells.length > 1) {
      // Insert two .js-gen elements after the first eligible cell
      const firstCell = cells[0];
      firstCell.insertAdjacentHTML('afterend', '<div class="cell blank js-gen"></div><div class="cell blank js-gen"></div>');
      
      // Insert one .js-gen element after the third eligible cell
      const thirdCell = cells[2];
      thirdCell.insertAdjacentHTML('afterend', '<div class="cell blank js-gen"></div>');

      // Insert one .js-gen element after the sixth eligible cell
      const sixthCell = cells[5];
      sixthCell.insertAdjacentHTML('afterend', '<div class="cell blank js-gen"></div>');
    }

    // Check if the total number of visible cells is divisible by 3
    const totalCells = cells.length;
    const remainder = totalCells % 3;

    if (remainder !== 0) {
      const numberOfEmptyCellsToAdd = 3 - remainder;
      const lastCell = cells[cells.length - 1];

      // Add the required number of empty cells to make the total divisible by 3
      for (let i = 0; i < numberOfEmptyCellsToAdd; i++) {
        lastCell.insertAdjacentHTML('afterend', '<div class="cell empty js-gen"></div>');
      }
    }
  }

  // Function to remove all .js-gen elements
  function removeJsGenElements() {
    const jsGenElements = document.querySelectorAll('.js-gen');
    jsGenElements.forEach(element => element.remove());
  }

  // Function to check the screen width and apply the appropriate changes
  function handleResize() {
    if (window.innerWidth <= 900) {
      removeJsGenElements();
      addJsGenElements();
    } else {
      removeJsGenElements();
    }
  }

  // Add event listener for window resize
  window.addEventListener('resize', handleResize);

  // Run on initial load
  handleResize();
})();
  }
  
});





// ## Language-Switcher -TS-2024-09-18 ## 
function changeLanguage() {
  const dropdown = document.getElementById('language-dropdown');
  const selectedLanguage = dropdown.value;
  let currentUrl = window.location.href;

  if (selectedLanguage === 'en') {
    if (!currentUrl.includes('/en/')) {
      // Add /en/ to the URL if not already present
      currentUrl = currentUrl.replace(window.location.origin, window.location.origin + '/en');
    }
  } else {
    if (currentUrl.includes('/en/')) {
      // Remove /en/ from the URL
      currentUrl = currentUrl.replace('/en', '');
    }
  }
  window.location.href = currentUrl;
}
document.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.getElementById('language-dropdown');
  if (window.location.pathname.startsWith('/en')) {
    dropdown.value = 'en';
  } else {
    dropdown.value = 'de';
  }
});







// Ausloggen
document.addEventListener('DOMContentLoaded', () => {
    // Überprüfen, ob der Benutzer eingeloggt ist
    const isLoggedIn = document.body.classList.contains('customer-logged-in');
    if (!isLoggedIn) {
        console.info('Benutzer ist nicht eingeloggt. Script wird nicht ausgeführt.');
        return;
    }
    // Ziel-Element: Das Konto-Link-Element
    const targetElement = document.querySelector('a.site-nav__link.site-nav__link--icon[href="/account"]');

    if (!targetElement) {
        console.warn('Ziel-Element für das Menü nicht gefunden.');
        return;
    }

    // Sprache des Browsers überprüfen
    const userLocale = navigator.language || navigator.userLanguage;
    const logoutText = userLocale.startsWith('de') ? 'Ausloggen' : 'Logout';

    // Menü erstellen
    const dropdownMenu = document.createElement('div');
    // Der Text des Dropdown-Menüs wird nicht direkt gesetzt, um doppelten Inhalt zu vermeiden
    dropdownMenu.innerHTML = '';
    dropdownMenu.style.position = 'absolute';
    dropdownMenu.style.backgroundColor = '#fff';
    dropdownMenu.style.border = '1px solid #ccc';
    dropdownMenu.style.padding = '10px';
    dropdownMenu.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
    dropdownMenu.style.cursor = 'pointer';
    dropdownMenu.style.display = 'none';

    // Link für Ausloggen hinzufügen
    const logoutLink = document.createElement('a');
    logoutLink.href = '/account/logout';
    logoutLink.textContent = logoutText;
    logoutLink.style.textDecoration = 'none';
    logoutLink.style.color = '#333';

    dropdownMenu.appendChild(logoutLink);
    document.body.appendChild(dropdownMenu);

    // Funktionen für Hover-Verhalten
    let hideTimeout;

    const showMenu = () => {
        clearTimeout(hideTimeout);
        const rect = targetElement.getBoundingClientRect();
        dropdownMenu.style.top = `${rect.bottom + window.scrollY}px`;
        dropdownMenu.style.left = `${rect.left + window.scrollX}px`;
        dropdownMenu.style.display = 'block';
    };

    const hideMenu = () => {
        hideTimeout = setTimeout(() => {
            dropdownMenu.style.display = 'none';
        }, 300);
    };

    // Events für Ziel-Element
    targetElement.addEventListener('mouseenter', showMenu);
    targetElement.addEventListener('mouseleave', hideMenu);

    // Events für das Dropdown-Menü
    dropdownMenu.addEventListener('mouseenter', () => clearTimeout(hideTimeout));
    dropdownMenu.addEventListener('mouseleave', hideMenu);
});




function initializeToggleFunctionality(targetElementSelector, targetHeight = 400, targetOpenHeight = 2000) {
    // Alle Elemente entsprechend dem Selektor auswählen
    const targetElements = document.querySelectorAll(targetElementSelector);

    // Sicherstellen, dass Elemente existieren
    if (!targetElements.length) {
        console.warn(`Keine Elemente für den Selektor '${targetElementSelector}' gefunden.`);
        return;
    }

    // Schleife für jede Instanz von targetElement
    targetElements.forEach((targetElement) => {
        // Überprüfen, ob bereits ein Button existiert
        const existingButton = targetElement.parentElement.querySelector("button.product-details__more-btn");
        if (existingButton) {
            console.log("Button existiert bereits für ein Ziel-Element:", targetElement);
            return;
        }

        // Den Button HTML-Inhalt definieren
        const buttonHTML = `
            <button class="product-details__more-btn text-and-image-more-btn">
                <span class="product-details__more-btn--more">Mehr ansehen</span>
                <span class="product-details__more-btn--less">Weniger ansehen</span>
                <span class="icon-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                        <path d="m256-424-56-56 280-280 280 280-56 56-224-223-224 223Z"/>
                    </svg>
                </span>
            </button>
        `;

        // Einen Wrapper für den Button erstellen
        const buttonWrapper = document.createElement("div");
        buttonWrapper.innerHTML = buttonHTML;

        // Sicherstellen, dass das erzeugte Element gültig ist, bevor es eingefügt wird
        const buttonElement = buttonWrapper.firstElementChild;
        if (!buttonElement) {
            console.warn("Button-Element konnte nicht erstellt werden.");
            return;
        }

        // Den Button nach dem Ziel-Element einfügen
        targetElement.insertAdjacentElement("afterend", buttonElement);

        // Stile dynamisch für das Ziel-Element anwenden
        targetElement.style.maxHeight = `${targetHeight}px`;
        targetElement.style.overflow = "hidden";
        targetElement.style.position = "relative";
        targetElement.style.transition = "max-height 0.5s ease";

        // Event-Listener für den Button hinzufügen
        buttonElement.addEventListener("click", function () {
            if (targetElement.classList.contains("no-toggle")) return; // Toggle überspringen, wenn no-toggle-Klasse vorhanden ist

            targetElement.classList.toggle("visible");
            buttonElement.classList.toggle("open");

            const moreBtn = buttonElement.querySelector(".product-details__more-btn--more");
            const lessBtn = buttonElement.querySelector(".product-details__more-btn--less");

            if (targetElement.classList.contains("visible")) {
                moreBtn.style.display = "none";
                lessBtn.style.display = "inline";
                targetElement.style.maxHeight = `${targetOpenHeight}px`;
            } else {
                moreBtn.style.display = "inline";
                lessBtn.style.display = "none";
                targetElement.style.maxHeight = `${targetHeight}px`;
            }
        });

        // Überprüfen, ob der Inhalt höher als die Zielhöhe ist
        if (targetElement.scrollHeight > targetHeight) {
            buttonElement.classList.add("visible");
            targetElement.classList.add("has-fade"); // Fade nur hinzufügen, wenn der Button sichtbar ist
            buttonElement.querySelector(".product-details__more-btn--more").style.display = "inline";
            buttonElement.querySelector(".product-details__more-btn--less").style.display = "none";
        } else {
            targetElement.classList.add("no-fade");
        }
    });
}

document.addEventListener("DOMContentLoaded", function () { // Funktion aufrufen und ein Ziel-Element, eingefahrene Höhe und ausgefahrene Höhe übergeben
  initializeToggleFunctionality(".product-single__meta .product-block:nth-of-type(3)", 400); // Produktbeschreibung oben auf Produktdetailseiten
  initializeToggleFunctionality(".do-toggle", 33, 2000); // Toggle-Funktion in /sections/ts-text-columns.liquid
});
